import { ZS_FAQ_ITEMS } from "../../data/mockZS";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { HelpCircle } from "lucide-react";

export const ZSFAQSection = () => (
  <section id="faq" className="relative py-24 lg:py-32 overflow-hidden">
    <div className="absolute inset-0 bg-white" />
    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#0049B3]/10 to-transparent" />
    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-[#0049B3]/5 border border-[#0049B3]/10 rounded-full px-4 py-2 mb-6">
          <HelpCircle className="w-4 h-4 text-[#0049B3]" />
          <span className="text-sm font-semibold text-[#0049B3]">Časté dotazy</span>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0F1B3D]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", lineHeight: '1.25' }}>
          Máte otázky?
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#0049B3] to-[#2B7AE0]"> Máme odpovědi.</span>
        </h2>
      </div>
      <Accordion type="single" collapsible className="space-y-4">
        {ZS_FAQ_ITEMS.map((item, index) => (
          <AccordionItem key={index} value={`item-${index}`} className="bg-[#F8FAFF] border border-[#E8EDF5] rounded-2xl px-6 overflow-hidden data-[state=open]:border-[#0049B3]/20 data-[state=open]:shadow-lg data-[state=open]:shadow-blue-900/5 transition-all duration-300">
            <AccordionTrigger className="text-left py-5 text-[#0F1B3D] font-semibold hover:text-[#0049B3] hover:no-underline transition-colors duration-300 [&[data-state=open]]:text-[#0049B3]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {item.question}
            </AccordionTrigger>
            <AccordionContent className="text-[#4A5B7A] leading-relaxed pb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
              {item.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
